"use client";

import { useTranslation } from '@/app/i18n/client';
import { SUPPORTED_LANGUAGES, changeLanguage } from '@/app/i18n/client';

/**
 * Hook to access translations while ensuring hydration safety
 */
export function useTranslations(ns?: string | string[]) {
  const { t, i18n } = useTranslation(ns);

  return {
    t,
    currentLanguage: i18n.language,
    changeLanguage,
    languages: [
      { code: 'en', name: 'English' },
      { code: 'de', name: 'Deutsch' },
      { code: 'fr', name: 'Français' },
      { code: 'es', name: 'Español' },
    ],
  };
}